"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "azzano-decimo": {
    "334fd075": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "capo-di-sopra": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f15f41cf": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "capo-di-sotto": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34cb2d84": [{
      "hkey": "8d9eb355",
      "slug": "borgo-colle-cesena-zuiano",
      "name": "Borgo Colle-Cesena-Zuiano",
      "primary": true,
      "skipSearch": false
    }],
    "cesena": [{
      "hkey": "8d9eb355",
      "slug": "borgo-colle-cesena-zuiano",
      "name": "Borgo Colle-Cesena-Zuiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "azzano-decimo"
    }],
    "fb1831ee": [{
      "hkey": "8d9eb355",
      "slug": "borgo-colle-cesena-zuiano",
      "name": "Borgo Colle-Cesena-Zuiano",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "8d9eb355",
      "slug": "borgo-colle-cesena-zuiano",
      "name": "Borgo Colle-Cesena-Zuiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c1ca9b8b": [{
      "hkey": "853fcd41",
      "slug": "corva-cinque-strade",
      "name": "Corva-Cinque Strade",
      "primary": true,
      "skipSearch": false
    }],
    "corva": [{
      "hkey": "853fcd41",
      "slug": "corva-cinque-strade",
      "name": "Corva-Cinque Strade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3938738a": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "piagno": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71a903e7": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "runtine": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51df4644": [{
      "hkey": "8d9eb355",
      "slug": "borgo-colle-cesena-zuiano",
      "name": "Borgo Colle-Cesena-Zuiano",
      "primary": true,
      "skipSearch": false
    }],
    "zuiano": [{
      "hkey": "8d9eb355",
      "slug": "borgo-colle-cesena-zuiano",
      "name": "Borgo Colle-Cesena-Zuiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "azzano-decimo"
    }],
    "81faf22a": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "fiumesino": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bea91e8b": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "fratte": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd585ac1": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "skipSearch": false
    }],
    "mantova": [{
      "hkey": "17972c7e",
      "slug": "azzano-decimo",
      "name": "Azzano Decimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;